import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const AdminPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EEF1FE',
      100: '#D4DBFC',
      200: '#B0BCFA',
      300: '#8C9DF7',
      400: '#687EF5',
      500: '#405FDB',
      600: '#3651C4',
      700: '#2C43AD',
      800: '#223596',
      900: '#18277F',
      950: '#0E1A68',
    },
    colorScheme: {
      light: {
        formField: {
          borderColor: '#E5E5E5',
          background: 'white',
          boxShadow: '0px 1px 2px 0px #0000000D',
          hoverBorderColor: '{primary.200}',
          placeholderColor: '#9ca3af',
          borderRadius: '4px',
        },
      },
    },
    components: {
      button: {
        colorScheme: {
          light: {
            root: {
              borderRadius: '8px !important',
              roundedBorderRadius: '8px !important',
              raisedShadow: '0px 1px 2px 2px #0000001f, 0px 0px 0px 0.8px #415abd !important',
              sm: {
                fontSize: '12px',
                paddingX: '12px !important',
              },
              primary: {
                hoverBackground: '{primary.600} !important',
              },
              secondary: {
                background: '#73737314 !important',
                borderColor: '#E6E6FF !important',
                hoverBackground: '#f7f7f7 !important',
              },
            },
          },
        },
      },
    },
  },
});

export default AdminPreset;
